export default __webpack_public_path__ + "static/media/lia-rozenfeld.bb7ecf4b.png";